import { createApiClient } from '@ems/api-client/client'

/**
 * The one client instance.
 *
 * Same-origin, always. In production the SPA and the API sit behind one CloudFront
 * distribution; in development Vite proxies `/v1`. Either way the tenant is resolved from the
 * Host, so there is no base URL to configure per tenant and no build-time environment variable
 * that could ship the wrong one — which is the failure a per-tenant SPA build would invite.
 */
export const api = createApiClient({ baseUrl: '' })
